import { useStore as baseUseStore } from 'vuex';
import type { LanguageListState } from '@/modules/shared/types/language.type';
import { storeKey } from '@/store';
import type { CaptionProfileListState } from '../types';

export const useStore = () => baseUseStore<{
  languageList: LanguageListState;
  captionProfileList: CaptionProfileListState;
}>(storeKey);
